import { useState } from 'react';
import { lt, showSuccessAlert } from '@mews/framework';
import { Button, Dialog } from '@optimus-web/core';
import { usePolicyExceptionDelete } from '../../../mutations';
import { useCurrentRateGroupContext, useCurrentServiceIdContext } from '../../../contexts';

interface Props {
    policyExceptionId?: string;
}
export const useDeletePolicyExceptionConfirmationDialog = ({ policyExceptionId }: Props) => {
    const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false);
    const { mutate, isPending } = usePolicyExceptionDelete();

    const { id: rateGroupId } = useCurrentRateGroupContext();
    const serviceId = useCurrentServiceIdContext();

    const handleCloseConfirmationDialog = () => {
        setIsConfirmationDialogOpen(false);
    };

    const handleDeletePolicyException = () =>
        policyExceptionId &&
        mutate(
            { policyOverrideId: policyExceptionId, rateGroupId, serviceId },
            {
                onSuccess: () => {
                    handleCloseConfirmationDialog();
                    showSuccessAlert({ title: lt('PolicyExceptionDeleteSuccessMessage') });
                },
            }
        );

    const confirmationDialog = (
        <Dialog
            active={isConfirmationDialogOpen}
            footer={{
                primary: (
                    <Button onClick={handleDeletePolicyException} variant="destructive" type="submit">
                        {lt('Delete')}
                    </Button>
                ),
                secondary: (
                    <Button onClick={handleCloseConfirmationDialog} variant="tertiary" type="submit">
                        {lt('GoBack')}
                    </Button>
                ),
            }}
            loading={isPending}
            onClose={handleCloseConfirmationDialog}
            title={lt('PolicyExceptionDeleteConfirmationDialogTitle')}
        >
            {lt('PolicyExceptionDeleteConfirmationDialogDescription')}
        </Dialog>
    );

    return {
        confirmationDialog,
        openConfirmationDialog: () => setIsConfirmationDialogOpen(true),
    };
};
